import styled from "@emotion/styled";
import CounterPage from "./pages/CounterPage";

const StyledTitle = styled.div`
 background-color: red;
 color: blue;
`;
export default () => (
  <CounterPage />
);
